import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import theme from "./src/theme";
import ScrollToTopButton from "./src/components/ScrollToTopButton";

// Global CSS für responsive Tabellen
import "./src/styles/global.css";

// Cookiebot nach window.load laden (LCP/INP Optimierung)
export const onInitialClientRender = () => {
  if (typeof window === "undefined") return;
  if (document.getElementById("Cookiebot")) return;

  const loadCookiebot = () => {
    if (document.getElementById("Cookiebot")) return;

    const s = document.createElement("script");
    s.id = "Cookiebot";
    s.src = "https://consent.cookiebot.com/uc.js";
    s.setAttribute("data-cbid", "bc0e9b79-341b-4787-868f-51890e9da79b");
    s.setAttribute("data-blockingmode", "auto");
    s.type = "text/javascript";
    s.async = true;
    s.defer = true;

    document.body.appendChild(s);
  };

  // Nach dem load Event, damit Cookiebot nicht den kritischen Render-Pfad blockiert
  if (document.readyState === "complete") {
    loadCookiebot();
  } else {
    window.addEventListener("load", loadCookiebot, { once: true });
  }
};

// Emotion Cache für Client (muss mit SSR übereinstimmen)
const key = "mui";
const cache = createCache({ key });

// Wrap Root Element mit ThemeProvider und CacheProvider
export const wrapRootElement = ({ element }) => (
  <CacheProvider value={cache}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {element}
    </ThemeProvider>
  </CacheProvider>
);

// Wrap Page Element mit dem ScrollToTopButton
export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <ScrollToTopButton />
  </>
);
